// extracted by mini-css-extract-plugin
export default {"form-container":"form_form-container__yf4Lu","line-text":"form_line-text__dUVJr"};